import TakerSummaryLine from "pages/PanelPage/components/charts/TakerSummaryLine/TakerSummaryLine";

export default TakerSummaryLine;
